<template>
    <div class="content">
        <title-header title="Comentários do Diretor"></title-header>
        <main class="main-area">
            <img class="image" :src="getFirstActveImage(main_article.imagens)" />
            <div class="text">
                <h1 v-html="main_article.titulo"></h1>
                <p v-html="main_article.noticia"></p>
            </div>
        </main>
        <latest-comments :noticias="ultimasNoticias" />
    </div>
</template>

<script>
import TitleHeader from '../../../../components/title/title'
import CommentsList from "../components/comments-list";

import axios from 'axios';
import LatestComments from "./latest-comments";
import imagesMixin from "../../../../mixins/images.mixin";

export default {
    name: "text-diretor",
    components: {
        LatestComments,
        CommentsList,
        TitleHeader,
    },
    mixins: [imagesMixin],
    data() {
        return {
            main_article: {},
            ultimasNoticias: []
        }
    },
    methods: {
        async getMainArticle(id){
            let response = await axios.get('get-noticia-atual/'+id)
            if (response.status == 200) {
                this.main_article = response.data.noticia
                this.ultimasNoticias = response.data.ultimasFooter
            }

            if (response.status > 400) {
                this.$swal({
                    title: 'Erro',
                    text: 'Algo de errado aconteceu.',
                    icon: 'error',
                })
            }

        }
    },
    created() {
        this.getMainArticle(this.$route.params.id)
    }
}
</script>

<style scoped lang="scss">
.content {
    max-width: 1280px;
    @apply mx-auto mb-16 p-8;
    main{
        @apply mb-16;
        .image {
            height: 300px;
            width: 300px;
            @apply float-left mr-8 mb-6 bg-primary rounded-lg;
        }
        @media(max-width: 640px){
            .image {
                @apply w-full mr-8 mb-6 bg-primary rounded-lg;
            }
        }
    }
}
</style>
